/* with love from shopstory */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function cleanString(value) {
  return value.replace(/\u2028/g, "");
}

exports.cleanString = cleanString;
